<template>
  <div :style="{height: `${textLeft.height}px`}">
    <div class="item">
      <div v-if="!textLeft.left" :style="{width: `${textLeft.imgWidth}px`}">
        <img style="width: inherit;" :src="textLeft.img" />
      </div>
      <div :style="{width: `${textLeft.textWidth}px`}">
        <div class="title">{{ textLeft.title }}</div>
        <div style="color: #999;">{{ textLeft.desc }}</div>
      </div>
      <div v-if="textLeft.left" :style="{width: `${textLeft.imgWidth}px`}">
        <img style="width: inherit;" :src="textLeft.img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextLeft',
  props: {
    textLeft: {
      type: Object,
      default: () => {
        return {
          height: 400, // 高度
          title: '', // 标题
          desc: '', // 简介
          textWidth: 500, // 文字的宽度
          imgWidth: 500, // 图片的宽度
          img: '', // 图片路径
          letf: true // true 字左         false 字右
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .item {
    border-bottom: 1px solid lightgray; height: inherit; width: 1200px;
    margin: 0 auto;display: flex;justify-content: space-between;align-items: center;
  }
  .title {
    font-size: 26px;margin-bottom: 20px;
  }
</style>
